import { DAY_TYPES } from '~/constants/organization_business_hour';
import { OrganizationBusinessHourDayType } from '~/graphql/generated/graphql';

export type BusinessHourEntry = {
  id?: string;
  dayType: OrganizationBusinessHourDayType;
  startTime: string;
  endTime: string;
};

export const resolveBusinessHours = (
  businessHours: BusinessHourEntry[] | null | undefined,
  medicalInformationNetBusinessHours: Omit<BusinessHourEntry, 'id'>[] | null | undefined,
): BusinessHourEntry[] => {
  if (businessHours && businessHours.length > 0) {
    return businessHours;
  }
  return medicalInformationNetBusinessHours ?? [];
};

export const formatBusinessHoursLines = (
  businessHours: Omit<BusinessHourEntry, 'id'>[] | null | undefined,
): string | null => {
  if (!businessHours || businessHours.length === 0) return null;

  return DAY_TYPES.map((day) => {
    const hours = businessHours.filter((hour) => hour.dayType === day.key);
    if (hours.length === 0) return `${day.shortLabel}：休業`;
    const timeParts = hours.map(
      (hour) => `${hour.startTime.slice(0, 5)}〜${hour.endTime.slice(0, 5)}`,
    );
    return `${day.shortLabel}：${timeParts.join('、')}`;
  }).join('\n');
};
